import styled from 'styled-components';

export const Textarea = styled.textarea`
  display: flex;
  width: 100%;
  min-height: 8rem;
  padding: 0.75rem 1rem;
  border-radius: 0;
  border: 1px solid ${({ theme }) => theme.colors.border};
  background: ${({ theme }) => theme.colors.background};
  color: ${({ theme }) => theme.colors.foreground};
  font-size: 0.875rem;
  font-family: inherit;
  resize: vertical;
  outline: none;

  &::placeholder {
    color: ${({ theme }) => theme.colors.mutedForeground};
    opacity: 0.85;
  }

  &:focus-visible {
    outline: none;
    box-shadow: 0 0 0 2px ${({ theme }) => theme.colors.ring};
    border-color: ${({ theme }) => theme.colors.champagne};
  }
`;
